import styled from 'styled-components'

import { pink, blue } from '../../../../styles/colors'

export const SelectItem = (props: {
  content: string | JSX.Element
  disclaimer?: string
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  key: React.Key
  selected?: boolean
  style?: React.CSSProperties
  showMarker?: boolean
}) => {
  const showMarker = props.showMarker === true

  if (typeof props.content === 'object') {
    return (
      <JSXSelectContainer
        onClick={props.onClick}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        selected={props.selected}
        showMarker={showMarker}
        style={props.style}
      >
        {props.content}
      </JSXSelectContainer>
    )
  }
  return (
    <SelectContainer
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      selected={props.selected}
      showMarker={showMarker}
      style={props.style}
    >
      <OptionRowMain>
        <span>{props.content}</span>
      </OptionRowMain>
      {props.disclaimer ? <Disclaimer>{props.disclaimer}</Disclaimer> : null}
    </SelectContainer>
  )
}

interface ISelectContainerProps {
  selected?: boolean
  showMarker?: boolean
}

const OPTION_ROW_SHARED = `
  box-sizing: border-box;
  padding: 0 8px;
  margin: 8px 0px;
  color: #686868;
  font-size: 14px;
  line-height: 1.25;
`

const optionRowShell = `
  ${OPTION_ROW_SHARED}
  height: 36px;
`

const OptionRowMain = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 100%;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const SelectContainer = styled.div<ISelectContainerProps>`
  ${optionRowShell}
  ${props =>
    !!props.onClick &&
    `
    cursor: pointer;
  `}
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  ${props =>
    props.showMarker &&
    `
    ${OptionRowMain} {
      transition: padding-left 0.5s;
      padding-left: ${props.selected ? '15px' : '0px'};
    }
    &::before {
      content: '•';
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      line-height: 1;
      color: ${props.selected ? `${blue}` : 'transparent'};
      transition: color 0.5s;
      pointer-events: none;
    }
    &:hover {
      ${OptionRowMain} {
        padding-left: 15px;
      }
      &::before {
        color: #073c7a;
      }
    }
  `}

  ${props =>
    !props.showMarker &&
    `
    ${OptionRowMain} span {
      transition: padding-left 0.5s;
      padding-left: ${props.selected ? '15px' : '0px'};
    }
    &:hover ${OptionRowMain} span {
      padding-left: 15px;
    }
  `}
`

const Disclaimer = styled.span`
  color: ${pink};
  font-size: 12px;
  flex-shrink: 0;
  margin-left: 8px;
`

const JSXSelectContainer = styled.div<ISelectContainerProps>`
  ${OPTION_ROW_SHARED}
  min-height: 36px;
  ${props =>
    !!props.onClick &&
    `
    cursor: pointer;
  `}
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  min-width: 0;

  /* Allow JSX rows (e.g. job type + %) to shrink inside the fixed-width panel instead of overflowing. */
  & > * {
    min-width: 0;
  }

  ${props =>
    props.showMarker &&
    `
    & > * {
      transition: padding-left 0.5s;
      padding-left: ${props.selected ? '15px' : '0px'};
    }
    &::before {
      content: '•';
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      line-height: 1;
      color: ${props.selected ? `${blue}` : 'transparent'};
      transition: color 0.5s;
      pointer-events: none;
    }
    &:hover {
      & > * {
        padding-left: 15px;
      }
      &::before {
        color: #073c7a;
      }
    }
  `}
`
